<template>
    <span @click="onClick">
        <slot :formattedDate="formattedDate">
            <span>{{ formattedDate }}</span>
        </slot>
    </span>
</template>

<script>
    import { format } from 'date-fns';

    export default {
        name: 'DisplayDate',
        props: {
            date: {
                type: Date,
                required: true,
            },
            format: {
                type: String,
                required: false,
                default: 'DD.MM.',
            }
        },
        computed: {
            formattedDate() {
                return format(this.date, this.format);
            }
        },
        methods: {
            onClick() {
                this.$emit('click', this.date);
            }
        },
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/shared/components/DisplayDate.vue